<template>
    <tr :class="`${isEditRequested || isRowExpanded ? 'edit-row' : ''}`">
        <!-- uncomment this once frequency watch weekly endpoint is fixed -->
        <!-- <td v-if="!isRowExpanded">
            <i class="fa fa-plus-circle cursor-pointer" @click="expandRow(frequencyItem)"></i>
        </td>
        <td v-if="isRowExpanded">
            <i class="fa fa-minus-circle cursor-pointer" @click="expandRow()"></i>
        </td> -->
        <td>
            <a href="javascript:void(0);" @click="handlePatientNameClick(frequencyItem)">
                <EmptyTextHandler :text="frequencyItem.PatientName"></EmptyTextHandler>
            </a>
        </td>
        <td>
            <EmptyTextHandler :text="frequencyItem.BranchName"></EmptyTextHandler>
        </td>
        <td>
            <EmptyTextHandler :text="frequencyItem.Discipline"></EmptyTextHandler>
        </td>
        <td>
            <EmptyTextHandler :text="frequencyItem.Frequency"></EmptyTextHandler>
        </td>
        <td>
            <EmptyTextHandler :text="getFrequencyStatusName(frequencyItem.FrequencyStatus)"></EmptyTextHandler>
        </td>
        <td>
            <EmptyTextHandler :text="formatDate(frequencyItem.StartDate)"></EmptyTextHandler>
        </td>
        <td>
            <EmptyTextHandler :text="formatDate(frequencyItem.EndDate)"></EmptyTextHandler>
        </td>
        <td v-if="frequencyItem.Variance === 0">
            <EmptyTextHandler :text="frequencyItem.VisitsScheduled"></EmptyTextHandler>
        </td>
        <td v-else>
            <div class="d-flex align-items-center">
                {{ frequencyItem.VisitsScheduled
                }}<i
                    class="fa fa-exclamation-triangle text-danger ml-2"
                    aria-hidden="true"
                    v-tooltip="{ title: 'Scheduled visits don’t match ordered visits for the week.' }"
                ></i>
            </div>
        </td>
        <td>
            <EmptyTextHandler :text="frequencyItem.VisitsOrdered"></EmptyTextHandler>
        </td>
        <td>
            <EmptyTextHandler :text="frequencyItem.Variance"></EmptyTextHandler>
        </td>
        <td class="text-right">
            <div v-if="!isEditRequested">
                <button type="button" class="btn table-btn btn-outline-info" @click="messageUser()">
                    Message User
                </button>
            </div>
            <i v-if="isEditRequested" class="fw-bold">Action in Progress</i>
        </td>
    </tr>
    <tr class="edit-row" v-if="isEditRequested">
        <td :colspan="columns" class="p-3">
            <FormSection v-if="isEditInProgress">
                <template #content>
                    <div class="p-5 d-flex flex-column text-center text-primary">
                        <i class="far fa-save fa-7x mr-2 animated slow flash infinite"></i>
                        <div class="big-text mt-1">
                            <b>Save Vaccine Record in Progress...</b>
                        </div>
                    </div>
                </template>
            </FormSection>
            <template v-else>
                <FrequencyWatchHosForm :close-send-message="cancel" />
            </template>
            <div class="text-center" v-if="!isEditInProgress">
                <button type="button" class="btn btn-outline-primary btn-md mt-2" @click="cancel()">Cancel</button>
            </div>
        </td>
    </tr>
    <tr class="edit-row" v-show="isRowExpanded">
        <td :colspan="columns" class="p-3">
            <table class="table table-responsive-md border border-gray">
                <thead>
                    <tr class="bg-table-header">
                        <th></th>
                        <th>Week</th>
                        <th>Ordered</th>
                        <th>Scheduled</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="isLoading" v-for="i of loadingCount" class="table-loading" :key="i">
                        <td v-for="i of loadingCount" :key="i">
                            <span class="shimmer-loading"></span>
                        </td>
                    </tr>

                    <tr class="table-empty" v-if="!isLoading && !isError && !hasData">
                        <td :colspan="columns">
                            <h3>No Tasks Found.</h3>
                        </td>
                    </tr>
                    <tr class="table-error" v-if="!isLoading && isError">
                        <td :colspan="columns">
                            <ErrorMessageHandler
                                title="Frequency Watch list"
                                v-on:try-again="getWeeklyFrequencyWatch(frequencyItem)"
                            />
                        </td>
                    </tr>
                </tbody>
                <template v-if="!isLoading && hasData">
                    <tbody v-for="item in page" :key="item.PatientId">
                        <tr>
                            <td v-if="!isWeeklyRowExpanded">
                                <i class="fa fa-plus-circle cursor-pointer" @click="expandWeeklyRow(item)"></i>
                            </td>
                            <td v-if="isWeeklyRowExpanded">
                                <i class="fa fa-minus-circle cursor-pointer" @click="expandWeeklyRow()"></i>
                            </td>
                            <td>{{ formatDate(item.StartOfWeek) }}-{{ formatDate(item.EndOfWeek) }}</td>
                            <td><EmptyTextHandler :text="item.VisitsOrdered"></EmptyTextHandler></td>
                            <td>
                                <EmptyTextHandler :text="item.VisitsScheduled"></EmptyTextHandler>
                            </td>
                            <td>
                                <button
                                    type="button"
                                    class="btn table-btn btn-outline-info"
                                    @click="openAddTaskForm(item)"
                                >
                                    Add Task
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </table>
        </td>
    </tr>
</template>

<script lang="ts" src="./FrequencyWatchHHRow.ts"></script>
